import { useQuery } from 'react-query';

import { GetSubsetsResponseDto } from '../../../../backend/src/matter/subset/dto/get-subsets.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { ApiError } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Case } from '@/types';

export type CaseWithDocCount = Case & { docCount: number };

export const useGetSubsets = (matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GetSubsetsResponseDto[]>(
    [QueryEntity.Subsets, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset`, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!matterId,
      // Poll every 5 seconds if any subset is processing
      refetchInterval: (data) => {
        const hasProcessing = data?.some((subset) => subset.status === 'processing');
        return hasProcessing ? 5000 : false;
      },
    },
  );
};
